<template>
  <div ref="root" class="fomo-landing" @click="navigateToCreate">
    <header class="site-header">
      <a href="#inicio" class="brand" aria-label="FOMO PLANES, inicio">
        <img
          :src="assets.wordmark"
          alt="FOMO PLANES"
          width="2724"
          height="176"
        />
      </a>
      <nav aria-label="Navegación principal">
        <a href="#experiencia">Cómo funciona</a
        ><a href="#comunidad">Beneficios</a><a href="#dinero">Por qué FOMO</a>
      </nav>
      <div class="header-actions">
        <FomoButton variant="primary" href="/events/new" data-create
          >Crear mi evento</FomoButton
        >
      </div>
      <div class="reading-progress" aria-hidden="true"></div>
    </header>
    <main>
      <section class="hero" id="inicio">
        <div class="hero-film" aria-hidden="true">
          <video
            muted
            autoplay
            loop
            playsinline
            preload="metadata"
            :poster="assets.nightImage"
          >
            <source :src="heroVideo" type="video/mp4" />
          </video>
        </div>
        <div class="hero-shade" aria-hidden="true"></div>
        <div class="hero-grain" aria-hidden="true"></div>
        <div class="hero-light" aria-hidden="true"></div>
        <div class="hero-main wrap">
          <div class="hero-copy">
            <p class="eyebrow">
              <span class="status-light"></span> TU EVENTO. TU COMUNIDAD. TU
              CONTROL.
            </p>
            <h1>
              Para eventos <br />que generan <br /><span class="hero-word"
                >FOMO<span>.</span></span
              >
            </h1>
            <p class="hero-value">
              <strong>Tu dinero, a diario.</strong> <br /><span
                >Crea comunidad. Impulsa tus ventas. Ten el control.</span
              >
            </p>
            <div class="hero-actions">
              <FomoButton variant="primary" href="/events/new" data-create
                >Crear mi evento</FomoButton
              ><FomoButton variant="secondary" icon="fas fa-play" data-tour
                >Ver cómo funciona</FomoButton
              >
            </div>
            <p class="hero-caption">
              Crear tu evento es gratis. Empieza con tu próxima fecha.
            </p>
          </div>
          <div class="hero-object" id="hero-object">
            <span class="object-caption"
              >QUE LO VEAN. <br />QUE QUIERAN ESTAR. <span>↙</span></span
            >
            <div class="ticket-aura" aria-hidden="true"></div>
            <div class="hero-pass" data-tilt>
              <div class="pass-side" aria-hidden="true"></div>
              <article class="event-pass">
                <div class="pass-art">
                  <img
                    class="pass-photo"
                    :src="assets.nightImage"
                    alt="Luces y público en un evento de FOMO"
                  /><img
                    class="pass-brand"
                    :src="assets.ticket"
                    alt="FOMO PLANES"
                  /><span class="pass-edition">01 / LA NOCHE ES TUYA</span>
                  <h2>AFTER <br />HOURS</h2>
                  <svg
                    class="pass-sigil"
                    aria-hidden="true"
                    viewBox="0 0 100 100"
                    fill="none"
                  >
                    <path
                      d="M50 6V94M6 50H94M19 19L81 81M19 81L81 19"
                      stroke="currentColor"
                      stroke-width="3"
                    />
                  </svg>
                </div>
                <div class="pass-cut" aria-hidden="true"></div>
                <div class="pass-admission">
                  <div>
                    <span>ACCESO / DEMO</span><strong>Pista general</strong
                    ><small>Una entrada. Una experiencia.</small>
                  </div>
                  <div class="pass-qr"><LaunchTicketQr /></div>
                </div>
              </article>
            </div>
            <div class="ticket-float float-left">
              <i class="fas fa-ticket-alt" aria-hidden="true"></i
              ><span
                >Tu próxima fecha. <br /><strong
                  >Su próximo gran plan.</strong
                ></span
              >
            </div>
            <div class="ticket-float float-right">
              <span class="status-light"></span
              ><span>Tu marca. <br /><strong>En cada detalle.</strong></span>
            </div>
          </div>
        </div>
        <div class="hero-bottom wrap">
          <span>EL EVENTO ES TUYO. EL CONTROL, TAMBIÉN.</span
          ><a href="#experiencia"
            >Desliza para vivirlo
            <i class="fas fa-arrow-down" aria-hidden="true"></i></a
          ><span class="demo-label">CREA · VENDE · CONTROLA</span>
        </div>
      </section>

      <section class="benefit-rail wrap" aria-label="Lo que ganas con FOMO">
        <a href="#dinero"
          ><span>01</span>
          <h2>Tu dinero, <br />a diario.</h2>
          <p>Recibe tu dinero directamente en tu cuenta bancaria.</p>
          <i class="fas fa-arrow-right" aria-hidden="true"></i
        ></a>
        <a href="#experiencia" data-go-scene="2"
          ><span>02</span>
          <h2>Impulsa <br />tus ventas.</h2>
          <p>Activa preventas. Descubre qué RRPP vende más.</p>
          <i class="fas fa-arrow-right" aria-hidden="true"></i
        ></a>
        <a href="#comunidad"
          ><span>03</span>
          <h2>Crea <br />comunidad.</h2>
          <p>Haz que te reconozcan y quieran volver a tu próxima fecha.</p>
          <i class="fas fa-arrow-right" aria-hidden="true"></i
        ></a>
        <a href="#experiencia" data-go-scene="3"
          ><span>04</span>
          <h2>Ten <br />el control.</h2>
          <p>Define cada localidad. Valida cada entrada.</p>
          <i class="fas fa-arrow-right" aria-hidden="true"></i
        ></a>
      </section>

      <section
        class="story-track"
        id="experiencia"
        aria-label="Recorrido interactivo de un evento"
      >
        <div class="story-sticky">
          <div class="story-frame" data-story-frame>
            <div class="story-top wrap">
              <span class="eyebrow">PUBLICA, VENDE Y VALIDA CON FOMO</span
              ><span class="scene-count"><b id="scene-count">01</b> / 04</span>
            </div>
            <div class="story-layout wrap">
              <div class="story-copy-stack">
                <article class="story-copy is-active" data-copy="0">
                  <span class="chapter-label">01 / TU PÁGINA DE VENTA</span>
                  <h2>Crea tu evento <br /><em>en minutos.</em></h2>
                  <p>
                    Ponle nombre, añade una portada y elige la fecha y el lugar.
                    Configura tus entradas y comparte tu enlace para empezar a
                    vender.
                  </p>
                  <div class="outcome">
                    <i class="fas fa-check" aria-hidden="true"></i
                    ><span>Tu público compra desde su celular.</span>
                  </div>
                  <FomoButton variant="primary" href="/events/new" data-create
                    >Crear mi evento</FomoButton
                  >
                </article>
                <article
                  class="story-copy"
                  data-copy="1"
                  aria-hidden="true"
                  inert
                >
                  <span class="chapter-label">02 / VENUE STUDIO</span>
                  <h2>
                    Diseña tu mapa. <br /><em>O crea tus localidades.</em>
                  </h2>
                  <p>
                    Ubica mesas, zonas y asientos en un mapa interactivo con
                    Venue Studio. ¿No necesitas mapa? Crea una lista de
                    localidades con sus precios y cupos.
                  </p>
                  <div class="outcome">
                    <i class="fas fa-check" aria-hidden="true"></i
                    ><span>Tú decides cómo se organiza tu evento.</span>
                  </div>
                  <FomoButton variant="primary" href="/events/new" data-create
                    >Crear mi evento</FomoButton
                  >
                </article>
                <article
                  class="story-copy"
                  data-copy="2"
                  aria-hidden="true"
                  inert
                >
                  <span class="chapter-label">03 / TU DASHBOARD</span>
                  <h2>
                    Controla tus ventas. <br /><em
                      >Decide el siguiente paso.</em
                    >
                  </h2>
                  <p>
                    Ve cuántas entradas vendes, cuánto has generado y qué
                    localidades se llenan. Todo en el dashboard de tu evento.
                  </p>
                  <ul class="sales-features">
                    <li>
                      <i class="fas fa-user-friends" aria-hidden="true"></i
                      >Códigos por RRPP
                    </li>
                    <li>
                      <i class="fas fa-bullhorn" aria-hidden="true"></i>Campañas
                      y promociones
                    </li>
                    <li>
                      <i class="fas fa-ticket-alt" aria-hidden="true"></i>Cupos
                      por localidad
                    </li>
                    <li>
                      <i class="fas fa-layer-group" aria-hidden="true"></i
                      >Etapas y precios
                    </li>
                  </ul>
                  <FomoButton variant="primary" href="/events/new" data-create
                    >Crear mi evento</FomoButton
                  >
                </article>
                <article
                  class="story-copy"
                  data-copy="3"
                  aria-hidden="true"
                  inert
                >
                  <span class="chapter-label">04 / CONTROL DE ACCESO</span>
                  <h2>Escanea el QR. <br /><em>Valida la entrada.</em></h2>
                  <p>
                    Escanea desde el celular y comprueba si la entrada es válida
                    o ya fue utilizada. Tu equipo sabe a quién dejar pasar.
                  </p>
                  <div class="outcome">
                    <i class="fas fa-check" aria-hidden="true"></i
                    ><span>Detecta entradas que ya fueron utilizadas.</span>
                  </div>
                  <FomoButton variant="primary" href="/events/new" data-create
                    >Crear mi evento</FomoButton
                  >
                </article>
              </div>
              <div class="product-theatre" id="product-theatre" data-scene="0">
                <div class="scene-watermark" aria-hidden="true">
                  <span>CREA</span><span>DISEÑA</span><span>VENDE</span
                  ><span>VALIDA</span>
                </div>
                <div class="theatre-floor" aria-hidden="true"></div>
                <div class="theatre-light" aria-hidden="true"></div>
                <div class="journey-pass" id="journey-pass">
                  <div class="journey-pass-photo">
                    <img :src="assets.nightImage" alt="" /><img
                      class="pass-brand"
                      :src="assets.ticket"
                      alt="FOMO PLANES"
                    /><span>AFTER <br />HOURS</span>
                  </div>
                  <div class="journey-perf" aria-hidden="true"></div>
                  <div class="journey-pass-bottom">
                    <div>
                      <small>ENTRADA / DEMO</small
                      ><strong id="journey-zone">Pista general</strong
                      ><span>AFTER HOURS · 001</span>
                    </div>
                    <div class="journey-qr"><LaunchTicketQr /></div>
                  </div>
                </div>
                <div class="identity-label theatre-layer" data-layer="0">
                  <span class="identity-dot"></span>Tu portada también aparece
                  en la entrada.
                </div>
                <div
                  class="venue-stage theatre-layer"
                  data-layer="1"
                  aria-hidden="true"
                  inert
                >
                  <div class="venue-title">
                    <img :src="assets.ticket" alt="FOMO PLANES" /><span
                      >VENUE STUDIO / DEMO</span
                    >
                  </div>
                  <div class="venue-space"><LaunchVenueMap /></div>
                  <div class="venue-selection fomo-dashboard-card">
                    <div>
                      <span>LOCALIDAD SELECCIONADA</span
                      ><strong id="selected-zone">Pista general</strong>
                    </div>
                    <span class="locality-link"
                      ><i class="fas fa-link" aria-hidden="true"></i> Vinculada
                      a su entrada</span
                    >
                  </div>
                  <div
                    class="venue-controls"
                    role="group"
                    aria-label="Explorar zonas del venue"
                  >
                    <FomoButton
                      variant="quiet"
                      icon=""
                      data-zone="pista"
                      aria-pressed="true"
                      >Pista</FomoButton
                    ><FomoButton
                      variant="quiet"
                      icon=""
                      data-zone="mesas"
                      aria-pressed="false"
                      >Mesas VIP</FomoButton
                    ><FomoButton
                      variant="quiet"
                      icon=""
                      data-zone="gradas"
                      aria-pressed="false"
                      >Gradas</FomoButton
                    >
                  </div>
                </div>
                <div
                  class="sales-stage theatre-layer"
                  data-layer="2"
                  aria-hidden="true"
                  inert
                >
                  <div class="sales-panel fomo-dashboard-card">
                    <div class="panel-bar">
                      <strong>Resumen de ventas</strong
                      ><span>DATOS DE EJEMPLO</span>
                    </div>
                    <div class="sales-kpis">
                      <div>
                        <span>Entradas vendidas</span
                        ><strong id="sales-count">84</strong>
                      </div>
                      <div>
                        <span>Ventas en USD</span
                        ><strong id="sales-revenue">$1.260</strong>
                      </div>
                      <div>
                        <span>Cupo vendido</span
                        ><strong id="sales-occupancy">70%</strong>
                      </div>
                    </div>
                    <div
                      class="sales-trend"
                      role="img"
                      aria-label="Ejemplo de ventas durante siete días"
                    >
                      <div class="sales-chart">
                        <span style="--height: 22%; --delay: 0s"
                          ><i></i><small>L</small></span
                        ><span style="--height: 35%; --delay: 0.06s"
                          ><i></i><small>M</small></span
                        ><span style="--height: 29%; --delay: 0.12s"
                          ><i></i><small>X</small></span
                        ><span style="--height: 54%; --delay: 0.18s"
                          ><i></i><small>J</small></span
                        ><span style="--height: 68%; --delay: 0.24s"
                          ><i></i><small>V</small></span
                        ><span style="--height: 61%; --delay: 0.3s"
                          ><i></i><small>S</small></span
                        ><span style="--height: 92%; --delay: 0.36s"
                          ><i></i><small>D</small></span
                        >
                      </div>
                    </div>
                    <div class="sales-breakdown-heading">
                      <span class="small-label">VENTAS POR RRPP</span>
                      <div
                        class="sales-tabs"
                        role="group"
                        aria-label="Etapa del ejemplo"
                      >
                        <FomoButton
                          variant="quiet"
                          icon=""
                          data-sale="preventa"
                          aria-pressed="true"
                          >Preventa</FomoButton
                        ><FomoButton
                          variant="quiet"
                          icon=""
                          data-sale="general"
                          aria-pressed="false"
                          >General</FomoButton
                        >
                      </div>
                    </div>
                    <div class="sales-row">
                      <span>Aurora<small>AURORA</small></span>
                      <div><i style="--bar: 84%"></i></div>
                      <b>42</b>
                    </div>
                    <div class="sales-row">
                      <span>Sur<small>SUR</small></span>
                      <div><i style="--bar: 54%"></i></div>
                      <b>27</b>
                    </div>
                    <div class="sales-row">
                      <span>Norte<small>NORTE</small></span>
                      <div><i style="--bar: 30%"></i></div>
                      <b>15</b>
                    </div>
                    <div class="sales-summary">
                      <span>Campaña <b>LANZAMIENTO</b></span
                      ><span>Cupo <b>120 entradas</b></span>
                    </div>
                  </div>
                </div>
                <div
                  class="access-stage theatre-layer"
                  data-layer="3"
                  aria-hidden="true"
                  inert
                >
                  <div class="access-window">
                    <span class="scanner-label">FOMO / CONTROL DE ACCESO</span
                    ><i class="corner tl"></i><i class="corner tr"></i
                    ><i class="corner bl"></i><i class="corner br"></i>
                    <div class="scanner-line"></div>
                    <span class="scanner-caption">SIMULACIÓN DE ESCANEO</span>
                  </div>
                  <div
                    class="access-result fomo-dashboard-card"
                    id="access-result"
                    aria-live="polite"
                  >
                    <span class="access-check"
                      ><i class="fas fa-check" aria-hidden="true"></i
                    ></span>
                    <div>
                      <strong id="access-title">Entrada reconocida</strong
                      ><span id="access-detail"
                        >AFTER HOURS · Pista general · Demo</span
                      >
                    </div>
                  </div>
                  <FomoButton
                    variant="quiet"
                    icon="fas fa-qrcode"
                    id="scan-demo"
                    >Probar el QR</FomoButton
                  >
                </div>
              </div>
            </div>
            <div
              class="chapter-nav wrap"
              role="group"
              aria-label="Capítulos del recorrido"
            >
              <button type="button" data-chapter="0" aria-pressed="true">
                <span>01</span> Crea <i></i></button
              ><button type="button" data-chapter="1" aria-pressed="false">
                <span>02</span> Diseña <i></i></button
              ><button type="button" data-chapter="2" aria-pressed="false">
                <span>03</span> Controla <i></i></button
              ><button type="button" data-chapter="3" aria-pressed="false">
                <span>04</span> Valida <i></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <LaunchBenefits />

      <LaunchDecision />

      <section class="pricing-section wrap" id="costos">
        <div class="pricing-copy">
          <p class="eyebrow">EMPIEZA CON LOS NÚMEROS CLAROS</p>
          <h2>
            Crea el próximo gran plan. <br /><em>Con los números claros.</em>
          </h2>
          <p>
            Entradas, venue, RRPP y accesos en el mismo lugar. Conoce el costo
            por entrada desde el principio.
          </p>
          <div class="included">
            <span>Venue Studio</span><span>RRPP</span><span>Etapas y cupos</span
            ><span>Cortesías gratis</span><span>QR y accesos</span
            ><span>Backstage</span>
          </div>
        </div>
        <div class="price-card fomo-dashboard-card">
          <span class="small-label">POR ENTRADA VENDIDA</span>
          <div class="price"><span>$</span>1<small>USD</small></div>
          <p>+ comisión de la pasarela de pago</p>
          <hr />
          <span class="price-note"
            >Puedes trasladar el fee de FOMO al comprador.</span
          ><FomoButton variant="primary" href="/events/new" data-create
            >Crear mi evento</FomoButton
          >
        </div>
      </section>

      <section class="faq-section wrap" id="preguntas">
        <div>
          <p class="eyebrow">ANTES DE TU PRÓXIMA FECHA</p>
          <h2>Todo claro.</h2>
        </div>
        <div class="faq-list">
          <details>
            <summary>¿Qué necesito para crear mi evento?<span>+</span></summary>
            <p>
              El nombre, la fecha, el lugar y una portada. Después configura tus
              entradas y completa los pasos para publicar.
            </p>
          </details>
          <details>
            <summary>¿Puedo vender mesas y asientos?<span>+</span></summary>
            <p>
              Sí. Diseña tu mapa en Venue Studio y deja que tu público elija su
              mesa, asiento o zona.
            </p>
          </details>
          <details id="faq-money">
            <summary>¿Cómo recibo mi dinero?<span>+</span></summary>
            <p>Tu dinero llega directamente a tu cuenta bancaria.</p>
          </details>
          <details>
            <summary>¿Cómo sé qué RRPP está vendiendo?<span>+</span></summary>
            <p>
              Cada RRPP tiene su código o enlace. En tu panel ves cuántas
              entradas vende cada uno.
            </p>
          </details>
          <details>
            <summary>¿Cuánto cuesta crear mi evento?<span>+</span></summary>
            <p>
              Crear tu evento es gratis. Por cada entrada vendida, el fee de
              FOMO es de $1 USD más la comisión de la pasarela. Puedes trasladar
              el fee de FOMO al comprador.
            </p>
          </details>
        </div>
      </section>

      <section class="closing">
        <img :src="assets.nightImage" alt="" class="closing-photo" />
        <div class="wrap closing-content">
          <p class="eyebrow">TU PRÓXIMO EVENTO EMPIEZA AQUÍ</p>
          <h2>Crea tu evento. <br /><em>Empieza a vender.</em></h2>
          <p class="closing-support">
            Entradas, Venue Studio, RRPP y control de acceso. Todo para tu
            próxima fecha. Crear tu evento es gratis.
          </p>
          <FomoButton variant="primary" href="/events/new" data-create
            >Crear mi evento</FomoButton
          ><img
            :src="assets.wordmark"
            alt="FOMO PLANES"
            class="closing-brand"
          />
          <p class="organizer-resources-link">
            <a href="/organizadores/"
              >Conoce las herramientas de FOMO y compara ticketeras por país
              →</a
            >
          </p>
          <div class="footer-line">
            <span>Para eventos que generan FOMO.</span
            ><span>Visualizaciones con datos de ejemplo</span
            ><a href="#inicio">Volver arriba ↑</a>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import FomoButton from "@/components/ui/FomoButton.vue";
import LaunchBenefits from "@/components/launch/LaunchBenefits.vue";
import LaunchDecision from "@/components/launch/LaunchDecision.vue";
import LaunchTicketQr from "@/components/launch/LaunchTicketQr.vue";
import LaunchVenueMap from "@/components/launch/LaunchVenueMap.vue";
import assets from "@/components/launch/assets";
import { mountLaunchMotion } from "@/components/launch/motion";
import "@/styles/fomo-dashboard.css";
import "@/styles/launch/landing.css";
import "@/styles/launch/transitions.css";
import "@/styles/launch/icons.css";

const root = ref(null);
const heroVideo = window.matchMedia("(max-width: 600px)").matches
  ? assets.nightMobileVideo
  : assets.nightVideo;
const router = useRouter();
let dispose = () => {};
function navigateToCreate(event) {
  const link = event.target.closest("a[data-create]");
  if (
    !link ||
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
    return;
  event.preventDefault();
  router.push({ name: "event-creation" });
}
onMounted(() => {
  const previousTitle = document.title;
  const title = "Crea tu evento con FOMO · Vende entradas y ten el control";
  const existingMeta = document.querySelector('meta[name="description"]');
  const description =
    existingMeta || document.head.appendChild(document.createElement("meta"));
  const previousDescription = description.getAttribute("content");
  description.name = "description";
  description.content =
    "Crea tu evento en minutos. Vende entradas, diseña tu mapa con Venue Studio y controla tus ventas y accesos con FOMO.";
  document.title = title;
  document.documentElement.classList.add("fomo-landing-page");
  const stopMotion = mountLaunchMotion(root.value);
  dispose = () => {
    stopMotion();
    document.documentElement.classList.remove("fomo-landing-page");
    if (document.title === title) document.title = previousTitle;
    if (!existingMeta) description.remove();
    else if (previousDescription === null)
      description.removeAttribute("content");
    else description.setAttribute("content", previousDescription);
  };
});
onBeforeUnmount(() => dispose());
</script>
